import { ConsentStatus, IConsentMeta, WorkflowID, WorkflowIDMap, WorkflowStatusMap, WorkflowType } from '@swing-therapeutics/surveybay/dist/types';
import { migrateConsentMetaDoc } from '@swing-therapeutics/surveybay/dist/utils/migrations';
import { DocumentData, DocumentSnapshot, firestore } from '../../utils/firebase';
import { User } from '../User';
import { ScheduleCallAbstract } from './ScheduleCallAbstract';

const findConsentDoc = (userUID: string, workflowType: WorkflowType) => {
  let workflowID = WorkflowID.CONSENT;
  if (workflowType === WorkflowType.EXTENSION) {
    workflowID = WorkflowID.EXT_CONSENT;
  }
  return firestore.collection(`users/${userUID}/workflows`).where('workflowID', '==', workflowID);
};

export class ConsentMeta extends ScheduleCallAbstract implements IConsentMeta {
  employeeName: string;
  notes: string;
  preConsentStatus: ConsentStatus;
  consentFormEnvelopeID: string;
  consentFormStatus: string;

  constructor(props: any) {
    super(props);
  }

  static fromFirestore(docSnap: DocumentSnapshot<DocumentData | undefined>): ConsentMeta {
    const data = docSnap.data();
    if (!data) {
      throw new Error('Consent meta doc has no data');
    }
    const consentMeta = new ConsentMeta(migrateConsentMetaDoc(data as IConsentMeta, WorkflowIDMap[data.workflowID as WorkflowID]));
    consentMeta.docPath = docSnap.ref.path;
    return consentMeta;
  }

  static async fromUser(user: User): Promise<ConsentMeta> {
    const collection = await findConsentDoc(user.uid, WorkflowStatusMap[user.workflowStatus]).get();
    const doc = collection.docs[0];
    if (!doc?.exists) {
      throw new Error('Consent meta doc doesnt exist for user');
    } else {
      return this.fromFirestore(doc);
    }
  }

  static async fromUserSubscribe(user: User, changeCallback: (preconsetMeta: ConsentMeta) => void): Promise<() => void> {
    try {
      const collection = await findConsentDoc(user.uid, WorkflowStatusMap[user.workflowStatus]).get();
      const doc = collection.docs[0];
      return doc.ref.onSnapshot((snap) => {
        if (!snap.exists) {
          return;
        }
        changeCallback(this.fromFirestore(snap));
      });
    } catch (error) {
      console.error(error);
      return () => {};
    }
  }
}
